import { CourseType } from "../CourseType.js";
import { Locale, type LocalizedString } from "../Locale.js";

export interface CourseTypeContent {
	shortDescription: LocalizedString;
	duration: LocalizedString;
	/** Unused for {@link CourseType.Workshop} - its price is set per {@link CourseTerm}. */
	priceWithTax: number;
}

export const courseTypeContentMap: Record<CourseType, CourseTypeContent> = {
	[CourseType.HomeFilterCoffee]: {
		shortDescription: {
			[Locale.cs]:
				"3-4hodinový kurz přípravy filtrované kávy v domácích podmínkách. Vhodné pro začátečníky i mírně pokročilé.",
			[Locale.en]:
				"A 3- to 4-hour course on brewing filter coffee at home. Suitable for beginners and slightly advanced.",
		},
		duration: {
			[Locale.cs]: "3–4 hodiny",
			[Locale.en]: "3–4 hours",
		},
		priceWithTax: 2400,
	},
	[CourseType.HomeEspresso]: {
		shortDescription: {
			[Locale.cs]:
				"4-5hodinový kurz přípravy espressa a mléčných nápojů na domácím kávovaru. Vhodné pro začátečníky i mírně pokročilé.",
			[Locale.en]:
				"A 4- to 5-hour course on brewing espresso and milk-based drinks on a home machine. Suitable for beginners and slightly advanced.",
		},
		duration: {
			[Locale.cs]: "4–5 hodin",
			[Locale.en]: "4–5 hours",
		},
		priceWithTax: 2900,
	},
	[CourseType.SCAFoundation]: {
		shortDescription: {
			[Locale.cs]:
				"Jednodenní kurz s certifikací SCA Barista Skills Foundation pro začínající baristy a všechny, kteří chtějí získat pevné základy práce s kávou.",
			[Locale.en]:
				"A one-day course with SCA Barista Skills Foundation certification for beginner baristas and anyone who wants to build solid fundamentals in coffee preparation.",
		},
		duration: {
			[Locale.cs]: "7 hodin výuky",
			[Locale.en]: "7 hours of training",
		},
		priceWithTax: 7900,
	},
	[CourseType.SCAIntermediate]: {
		shortDescription: {
			[Locale.cs]:
				"Dvoudenní kurz s certifikací SCA Barista Skills Intermediate pro pokročilé baristy, kteří se chtějí více ponořit do znalostí kávy a samotné přípravy.",
			[Locale.en]:
				"A two-day course with SCA Barista Skills Intermediate certification for advanced baristas who want to deepen their knowledge of coffee and preparation techniques.",
		},
		duration: {
			[Locale.cs]: "14 hodin výuky",
			[Locale.en]: "14 hours of training",
		},
		priceWithTax: 9900,
	},
	[CourseType.Workshop]: {
		shortDescription: {
			[Locale.cs]: "Ochutnávkový workshop pro milovníky kávy, kteří chtějí objevit nové chutě a způsoby přípravy.",
			[Locale.en]: "A tasting workshop for coffee lovers who want to discover new flavors and brewing methods.",
		},
		duration: {
			[Locale.cs]: "2–3 hodiny",
			[Locale.en]: "2–3 hours",
		},
		priceWithTax: 0,
	},
};
